const isBrowser = String(process.env.BROWSER) === 'true';

export default isBrowser;
